function OffenderAlcoholTestResult() {
    "use strict";
    this.__type = 'OffenderAlcoholTestResult:www.veritracks.com';
    this.UpdateUTC = null;
    this.EnrolleeId = -1;
    this.StartDate = null;
    this.StopDate = null;
    this.ScheduleType = -1;
    this.ScheduleTypeName = '';
    this.StatusId = -1;
    this.StatusName = '';
    this.Name = '';
    this.Longitude = -1;
    this.Latitude = -1;
    this.IsActive = -1;
    this.Bac = 0;
    this.BacLimit = 0;
    this.ImageId = -1;
    this.Id = -1;

}
if (typeof exports !== 'undefined') {
    module.exports = OffenderAlcoholTestResult;
}